import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaPaperPlane, FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  const contactInfo = [
    {
      icon: <FaPhone />,
      title: 'Téléphone',
      value: '+243 838 249 020',
      href: 'tel:+243838249020',
    },
    {
      icon: <FaEnvelope />,
      title: 'Email',
      value: 'jb@liviatech.store',
      href: 'mailto:jb@liviatech.store',
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Localisation',
      value: 'République Démocratique du Congo',
    },
    {
      icon: <FaClock />,
      title: 'Disponibilité',
      value: 'Lun - Sam : 8h00 - 18h00',
    },
  ];

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Contact</span>
          <h2 className="section-title">Parlons de votre projet</h2>
          <p className="section-subtitle">
            Une question, un projet, une idée ? Notre équipe est à votre écoute
            pour vous accompagner dans votre transformation digitale et professionnelle.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h3>Contactez-nous</h3>
            <p>
              Que vous soyez une entreprise, une organisation, un professionnel ou un particulier,
              nous sommes à votre écoute pour discuter de vos besoins et vous proposer
              les solutions les plus adaptées.
            </p>

            <div className="contact-info-list">
              {contactInfo.map((info, index) => (
                <div className="contact-info-item" key={index}>
                  <div className="contact-info-icon">{info.icon}</div>
                  <div className="contact-info-content">
                    <span className="contact-info-title">{info.title}</span>
                    {info.href ? (
                      <a href={info.href} className="contact-info-value">
                        {info.value}
                      </a>
                    ) : (
                      <span className="contact-info-value">{info.value}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="contact-socials">
              <span className="contact-socials-label">Suivez-nous</span>
              <div className="contact-socials-list">
                <a href="https://www.facebook.com/share/1Jb6PtxQXt/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="contact-social" aria-label="Facebook">
                  <FaFacebookF />
                </a>
                <a href="https://instagram.com/liviatech" target="_blank" rel="noopener noreferrer" className="contact-social" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://linkedin.com/company/liviatech" target="_blank" rel="noopener noreferrer" className="contact-social" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>
                <a href="https://wa.me/243838249020" target="_blank" rel="noopener noreferrer" className="contact-social" aria-label="WhatsApp">
                  <FaWhatsapp />
                </a>
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Nom complet</label>
                  <input type="text" id="name" name="name" placeholder="Votre nom" required />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input type="email" id="email" name="email" placeholder="votre@email.com" required />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Téléphone</label>
                  <input type="tel" id="phone" name="phone" placeholder="+243 ..." />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Sujet</label>
                  <select id="subject" name="subject" required>
                    <option value="">Choisissez un sujet</option>
                    <option value="web">Développement web & plateformes</option>
                    <option value="mobile">Applications mobiles</option>
                    <option value="gestion">Solutions de gestion & traçabilité</option>
                    <option value="tracking">Tracking & géolocalisation</option>
                    <option value="zwacop">ZWACOP — Mise en relation</option>
                    <option value="eden">EDEN Manager — Gestion</option>
                    <option value="ingenierie">Ingénierie & IBTP</option>
                    <option value="agriculture">Agriculture & agrotech</option>
                    <option value="sous-traitance">Sous-traitance & services</option>
                    <option value="autre">Autre demande</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  placeholder="Décrivez votre projet ou votre demande..."
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary btn-lg btn-full">
                Envoyer le message <FaPaperPlane className="btn-icon" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;